// ============================================================================
// API CONFIGURATION
//
// API keys live on the backend (server/.env). The frontend never sees them —
// all market data requests are proxied through /api/market/polygon which
// injects the key server-side.
// ============================================================================

// Base URL for all backend API calls (same as backendApi.js)
export const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

// Client-side rate-limit ceiling (calls/minute) — prevents hammering the proxy.
export const API_CONFIG = {
  polygon: { rateLimit: 5 },
};

// Market data is always available — keys live on the server.
export function hasApiKeys() {
  return true;
}

export function getConfiguredProviders() {
  return ['Polygon.io'];
}
